//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




export default {

  data () {
    return {
      is_old:false
    }
  },

  methods: {
    open(id){
      var ios_message = null;
      var android_message = null;
      if(id == 1){
        ios_message = {"method":"openPaper",data:{"to":"http://msb.nhnews.com.cn/nhbxwd/qamobile/index.php/qamobile/knhload"}};
        android_message = "{\"method\":\"openPaper\",data:{\"to\":\"http://msb.nhnews.com.cn/nhbxwd/qamobile/index.php/qamobile/knhload\"}}";
      }else if(id == 2){
        ios_message = {"method":"openPaper",data:{"to":"http://zbnh.tv/dianbo_list.aspx?cid=2150"}};
        android_message = "{\"method\":\"openPaper\",data:{\"to\":\"http://zbnh.tv/dianbo_list.aspx?cid=2150\"}}";
      }else if(id == 3){
        ios_message = {"method":"openPaper",data:{"to":"http://nh.cnnb.com.cn/bxsmsb/jzcj/"}};
        android_message = "{\"method\":\"openPaper\",data:{\"to\":\"http://nh.cnnb.com.cn/bxsmsb/jzcj/\"}}";
      }/*else if(id == 4){
       ios_message = {"method":"openPaper",data:{"to":"yp://app?type=channel&id=94"}};
       android_message = "{\"method\":\"openPaper\",data:{\"to\":\"yp://app?type=channel&id=94\"}}";
       }*/else if(id == 5){
        /* ios_message = {"method":"openPaper",data:{"to":"http://msb.nhnews.com.cn/nhbxwd/qamobile/index.php/qamobile/knhload"}};
         android_message = "{\"method\":\"openPaper\",data:{\"to\":\"http://msb.nhnews.com.cn/nhbxwd/qamobile/index.php/qamobile/knhload\"}}";*/
      }else if(id == 6){
        ios_message = {"method":"openPaper",data:{"to":"http://msb.nhnews.com.cn/nhbxwd/qamobile/index.php/qamobile/list?id=1"}};
        android_message = "{\"method\":\"openPaper\",data:{\"to\":\"http://msb.nhnews.com.cn/nhbxwd/qamobile/index.php/qamobile/list?id=1\"}}";
      }else if(id == 7){
        ios_message = {"method":"openPaper",data:{"to":"http://msb.nhnews.com.cn/nhbxwd/qamobile/index.php/qamobile/list?id=2"}};
        android_message = "{\"method\":\"openPaper\",data:{\"to\":\"http://msb.nhnews.com.cn/nhbxwd/qamobile/index.php/qamobile/list?id=2\"}}";
      }else if(id == 8){
        ios_message = {"method":"openPaper",data:{"to":"http://msb.nhnews.com.cn/nhbxwd/qamobile/index.php/qamobile/list?id=3"}};
        android_message = "{\"method\":\"openPaper\",data:{\"to\":\"http://msb.nhnews.com.cn/nhbxwd/qamobile/index.php/qamobile/list?id=3\"}}";
      }

      var u = navigator.userAgent, app = navigator.appVersion;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        window.webkit.messageHandlers.Native.postMessage(ios_message);
      }
      if(isAndroid){
        window.Native.postMessage(android_message);
      }

    }
  },

  mounted () {
    var u = navigator.userAgent;
    this.is_old = u.indexOf('watchninghai') > -1
  }
}





// WEBPACK FOOTER //
// ./src/pages/wz/wz_index.vue